import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { getOtherStoreDefinition } from "../visoria/stores";

const SITE_URL = "https://trendy-eng-shop.ru";
const DEFAULT_META = {
  title: "Trendy shop — карты пополнения Nintendo eShop, Steam и PlayStation",
  description:
    "Карты пополнения Nintendo eShop, Steam, PlayStation и других сервисов с оплатой через СБП. Код приходит сразу после оплаты. Скидки и цены игр в рублях.",
};

const PAGE_META = [
  {
    path: "/",
    title: "Карты Nintendo eShop и PlayStation, пополнение Steam — Trendy shop",
    description:
      "Карты пополнения Nintendo eShop (США, Польша) и PlayStation Store (Польша, Индия), пополнение Steam из России и СНГ. Оплата по СБП, код сразу после оплаты.",
  },
  {
    path: "/nintendo-eshop/shop",
    title: "Купить карту Nintendo eShop США и Польши — Trendy shop",
    description:
      "Карты пополнения Nintendo eShop для аккаунтов США и Польши с оплатой через СБП. Код приходит сразу после оплаты.",
  },
  {
    path: "/nintendo-discount",
    title: "Скидки Nintendo Switch сегодня — распродажи eShop США, Европы и Польши",
    description:
      "Актуальные скидки Nintendo eShop по регионам с ценами в рублях: США, Европа, Польша, Канада, Бразилия, Швеция. Купите карту пополнения и оплатите игру.",
  },
  {
    path: "/steam/topup",
    title: "Пополнение Steam из России по логину — оплата СБП | Trendy shop",
    description:
      "Пополните кошелёк Steam из России и СНГ: введите логин и сумму в рублях, оплатите по СБП. Деньги зачисляются на аккаунт — это не код. Сумма от 150 до 25 000 ₽, ПСК до 3%.",
  },
  {
    path: "/steam/shop",
    title: "Купить игры Steam в России — Trendy shop",
    description: "Покупка игр Steam из России с оплатой через СБП.",
  },
  {
    path: "/steam-discount",
    title: "Скидки Steam сегодня — распродажи и лучшие цены | Trendy shop",
    description: "Актуальные скидки и распродажи Steam с ценами в рублях.",
  },
  {
    path: "/playstation/shop",
    title: "Карты PlayStation Store — пополнение PSN из России | Trendy shop",
    description:
      "Карты пополнения PlayStation Network для PS5 и PS4 с оплатой через СБП. Код приходит сразу после оплаты.",
  },
  {
    path: "/playstation-discount",
    title: "Скидки PlayStation Store сегодня — распродажи PS5 и PS4",
    description: "Актуальные скидки PlayStation Store по регионам с ценами в рублях.",
  },
  { path: "/offer", title: "Договор публичной оферты — Trendy shop" },
  {
    path: "/privacy",
    title: "Политика обработки персональных данных — Trendy shop",
    description:
      "Как Trendy shop обрабатывает и защищает персональные данные: оператор, цели, состав данных, сроки хранения и права пользователей.",
  },
  {
    path: "/consent",
    title: "Согласие на обработку персональных данных — Trendy shop",
    description:
      "Текст согласия на обработку персональных данных покупателей Trendy shop: оператор, цели, состав данных, срок действия и порядок отзыва.",
  },
  { path: "/cookies-info", title: "Использование cookie — Trendy shop" },
];

const NOINDEX_PREFIXES = ["/vs-ops", "/store/order/", "/steam/payment-"];

function storeMeta(storeId) {
  const store = getOtherStoreDefinition(storeId);
  if (!store) {
    return null;
  }
  return {
    title: `Купить ${store.genre || store.pageTitle} — оплата СБП | Trendy shop`,
    description: store.description,
  };
}

function resolveMeta(pathname) {
  const page = PAGE_META.find((item) => matchPath(item.path, pathname));
  if (page) {
    return { ...DEFAULT_META, ...page, canonical: page.path };
  }
  const store = matchPath("/store/:storeId", pathname);
  if (store) {
    const meta = storeMeta(store.params.storeId);
    if (meta) {
      return { ...DEFAULT_META, ...meta, canonical: pathname };
    }
  }
  return null;
}

function setMetaTag(name, content) {
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!content) {
    tag?.remove();
    return;
  }
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(path) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!path) {
    link?.remove();
    return;
  }
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", `${SITE_URL}${path}`);
}

/** Заголовок, описание, canonical и robots для текущего маршрута SPA. */
export function usePageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = resolveMeta(pathname);
    const hidden = NOINDEX_PREFIXES.some((prefix) => pathname.startsWith(prefix));
    document.title = meta?.title || DEFAULT_META.title;
    setMetaTag("description", meta?.description || DEFAULT_META.description);
    setCanonical(meta && !hidden ? meta.canonical : null);
    setMetaTag("robots", meta && !hidden ? null : "noindex,follow");
  }, [pathname]);
}
